import { Grid } from '@mui/material';
import React from 'react';
import AgeSpecificCompetencies from './AgeSpecificCompetencies';
import ReferenceEvaluation from './ReferenceEvaluation';
import ReferenceActivity from './ReferenceActivity';

const ReferenceAdditionalInfo = ({ referenceDetails, disabled }: { referenceDetails: any; disabled: boolean }) => {
  return (
    <Grid container spacing={4} p={4}>
      <Grid item xs={2.75}>
        <AgeSpecificCompetencies ageCompetency={referenceDetails?.ageCompetency} disabled={disabled} />
      </Grid>
      <Grid item xs={3.75}>
        <ReferenceEvaluation evaluation={referenceDetails?.referenceEvaluation} disabled={disabled} />
      </Grid>
      <Grid item xs={5.5}>
        <ReferenceActivity activityHistory={referenceDetails?.activityHistory} disabled={disabled} />
      </Grid>
    </Grid>
  );
};

export default React.memo(ReferenceAdditionalInfo);
